import styles from "./gradientTextComponent.module.scss";
export const GradientTextComponent = (props) => {
  const { children } = props;
  return <span className={styles.gradientText}>{children}</span>;
};
